const sectionSelector = '.extra-services';
const tabSelector = '.extra-services__tab';
const contentSelector = '[data-content]';

const activeTabClassName = 'extra-services__tab--active';
const activeContentClassName = 'extra-services__content--active';

function setActiveTab(tabs, activeTabName) {
    tabs.forEach((tab) => {
        const isActive = tab.dataset.tabItem === activeTabName;

        tab.classList.toggle(activeTabClassName, isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
    });
}

function setActiveContents(contents, activeTabName) {
    contents.forEach(content => {
        const active = content.dataset.content === activeTabName;
        content.classList.toggle(activeContentClassName, active);
        content.setAttribute('aria-hidden', String(!active));
        content.inert = !active;
    });
}

export function animateServiceText(outgoing, incoming) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return [];
    }

    const direction = getComputedStyle(incoming).direction === 'rtl' ? -1 : 1;
    return [
        outgoing.animate([
            { opacity: 1, transform: 'translateX(0)' },
            { opacity: 0, transform: `translateX(${direction * 12}px)` },
        ], { duration: 180, easing: 'ease-out', fill: 'both' }),
        incoming.animate([
            { opacity: 0, transform: `translateX(${-direction * 16}px)` },
            { opacity: 1, transform: 'translateX(0)' },
        ], { duration: 420, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' }),
    ];
}

export function initExtraServicesSection() {
    document.querySelectorAll(sectionSelector).forEach((section) => {
        const tabs = Array.from(section.querySelectorAll(tabSelector));
        const contents = Array.from(section.querySelectorAll(contentSelector));
        let transitionId = 0;
        let textAnimations = [];

        if (!tabs.length || !contents.length) {
            return;
        }

        const activateTab = async (tab) => {
            const nextContent = contents.find(content => content.dataset.content === tab.dataset.tabItem);
            if (!nextContent || tab.classList.contains(activeTabClassName)) {
                return;
            }

            const id = ++transitionId;
            textAnimations.forEach(animation => animation.cancel());
            const previousContent = contents.find(content => content.classList.contains(activeContentClassName));
            setActiveTab(tabs, tab.dataset.tabItem);
            setActiveContents(contents, tab.dataset.tabItem);
            textAnimations = previousContent ? animateServiceText(previousContent, nextContent) : [];

            try {
                await Promise.all(textAnimations.map(animation => animation.finished));
                if (id === transitionId) {
                    textAnimations.forEach(animation => animation.cancel());
                    textAnimations = [];
                }
            } catch {
                // Следующий выбор отменяет предыдущий переход.
            }
        };

        const activeTab = tabs.find(tab => tab.classList.contains(activeTabClassName)) || tabs[0];
        setActiveTab(tabs, activeTab.dataset.tabItem);
        setActiveContents(contents, activeTab.dataset.tabItem);

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => activateTab(tab));
            tab.addEventListener('keydown', (event) => {
                let nextIndex;
                const direction = getComputedStyle(tab).direction === 'rtl' ? -1 : 1;

                switch (event.key) {
                case 'ArrowRight': nextIndex = index + direction; break;
                case 'ArrowLeft': nextIndex = index - direction; break;
                case 'ArrowDown': nextIndex = index + 1; break;
                case 'ArrowUp': nextIndex = index - 1; break;
                case 'Home': nextIndex = 0; break;
                case 'End': nextIndex = tabs.length - 1; break;
                default: return;
                }

                event.preventDefault();
                const nextTab = tabs[(nextIndex + tabs.length) % tabs.length];
                activateTab(nextTab);
                nextTab.focus();
            });
        });
    });
}
